var $a222e05de6d8dce8$exports = {};
$a222e05de6d8dce8$exports = {
    "(optional)": `(neoblig\u{101}ti)`,
    "(required)": `(oblig\u{101}ti)`
};


export {$a222e05de6d8dce8$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
